import RefrigeratorIcon from "../components/shared/icons/RefrigeratorIcon";
import IsothermalIcon from "../components/shared/icons/IsothermalIcon";
import CoveredIcon from "../components/shared/icons/CoveredIcon";
import AwningIcon from "../components/shared/icons/AwningIcon";
import OnboardIcon from "../components/shared/icons/OnboardIcon";
import PlatformIcon from "../components/shared/icons/PlatformIcon";
import CisternIcon from "../components/shared/icons/CisternIcon";
import ContainerShipIcon from "../components/shared/icons/ContainerShipIcon";
import DumpTruckIcon from "../components/shared/icons/DumpTruckIcon";
import CarTransporterIcon from "../components/shared/icons/CarTransporterIcon";
import RailwayIcon from "../components/shared/icons/RailwayIcon";
import ContainerIcon from "../components/shared/icons/ContainerIcon";

export const CLIENT_ORDER_STATUSES = ['all', 'moderation', 'awaitingpayment', 'awaiting-loading',
    'inprocess', 'completed', 'canceled'];

export const EXPEDITOR_ORDER_STATUSES = ['all', 'booked', 'confirmed', 'inprocess', 'waitingforcompletion', 'completed'];


export const ORDER_STATUSES_DATA = (t) => ({
    'moderation': { title: t('mockData.orderStatuses.moderation'), color: '#FF8502' },
    'awaitingpayment': { title: t('mockData.orderStatuses.awaitingpayment'), color: '#FBC334' },
    'published': { title: t('mockData.orderStatuses.published'), color: '#2857FC' },
    'booked': { title: t('mockData.orderStatuses.booked'), color: '#FA1861' },
    'confirmed': { title: t('mockData.orderStatuses.confirmed'), color: '#0275d8' },
    'processloadingcargo': { title: t('mockData.orderStatuses.processloadingcargo'), color: '#3A50C6' },
    'loadingcargomoderation': { title: t('mockData.orderStatuses.loadingcargomoderation'), color: '#3A50C6' },
    // 'rejectedloadingcargomoderation': { title: t('mockData.orderStatuses.rejectedloadingcargomoderation'), color: '#A3ACB6' },
    'waitstarttrip': { title: t('mockData.orderStatuses.waitstarttrip'), color: '#3A50C6' },
    'onthetrip': { title: t('mockData.orderStatuses.onthetrip'), color: '#048848' },
    'processunloadingcargo': { title: t('mockData.orderStatuses.processunloadingcargo'), color: '#0275d8' },
    'unloadingcargomoderation': { title: t('mockData.orderStatuses.unloadingcargomoderation'), color: '#0275d8' },
    'rejectedunloadingcargomoderation': { title: t('mockData.orderStatuses.rejectedunloadingcargomoderation'), color: '#A3ACB6' },
    'completed': { title: t('mockData.orderStatuses.completed'), color: '#458a48' },
    'rejected': { title: t('mockData.orderStatuses.rejected'), color: '#A3ACB6' },
    'canceled': { title: t('mockData.orderStatuses.canceled'), color: '#A3ACB6' },
    'awaitingoffer': { title: t('mockData.orderStatuses.awaitingoffer'), color: '#FF8502' },
    'assigned': { title: t('mockData.orderStatuses.assigned'), color: '#c5115e' },
    'assignedexecutor': { title: t('mockData.orderStatuses.assignedexecutor'), color: '#c1a944' },
    'expeditorrejected': { title: t('mockData.orderStatuses.expeditorrejected'), color: '#8f97a8' },
    'completedbyexecutor': { title: t('mockData.orderStatuses.completedbyexecutor'), color: '#68c66d' },
    // Дополнительные статусы (возможно не все используются)
    'waitloadingcargo': { title: t('mockData.orderStatuses.waitloadingcargo'), color: '#3A50C6' },
    'accepted': { title: t('mockData.orderStatuses.accepted'), color: '#3A50C6' },
    'unloadingcargo': { title: t('mockData.orderStatuses.unloadingcargo'), color: '#048848' },
    'loadingcargo': { title: t('mockData.orderStatuses.loadingcargo'), color: '#048848' },
    'waitcompletion': { title: t('mockData.orderStatuses.waitcompletion'), color: '#40AD45' },
    'delivered': { title: t('mockData.orderStatuses.delivered'), color: '#4b7dba' },
    'headingtoloading': { title: t('mockData.orderStatuses.headingtoloading'), color: '#1d0093ff' },
    'return': { title: t('mockData.orderStatuses.return'), color: '#212529' },
    'awaitingaction': { title: t('mockData.orderStatuses.awaitingaction'), color: '#E5373C' }
});

export const INVOICE_STATUSES_DATA = {
    'awaitingpayment': {title: 'Не оплачен', color: '#f0be39'},
    "paid": {title: 'Оплачен', color: '#5cb85c'},
}

export const ACTIVE_DATA = [
    {name: 'По актуальности', code: 'status'},
    {name: 'По дате создания заявки', code: 'createDate'},
    {name: 'По стоимости', code: 'price'},
]

// export const ORDER_STATUSES_DATA = {
//     'published': {title: 'ДОСТУПЕН', color: '#f0be39'}, 
//     'booked': {title: 'НА РАССМОТРЕНИИ', color: '#f0ad4e'}, 
//     'confirmed': {title: 'НАЗНАЧЕН', color: '#5cb85c'}, 
//     'inprocess': {title: 'В ПУТИ', color: '#0275d8'}, 
//     'completed': {title: 'ВЫПОЛНЕН', color: '#A3195B'}
// }

export const CLIENT_TABS = (t) => [
  { key: "all", statuses: ["all"], title: t("common.status.tabsList.all")},
  { key: "tender", statuses: ["awaitingoffer"], title: t("common.status.tabsList.tenderOpened"), isExpiredTender: false},
  { key: "expiredTender", statuses: ["awaitingoffer"], title: t("common.status.tabsList.tenderCompleted"), isExpiredTender: true},
  { key: "confirmed", statuses: ["assigned", "assignedexecutor", "booked", "Confirmed"], title: t("common.status.tabsList.confirmed")},
  { key: "loadingcargo", statuses: ["headingtoloading", "loadingcargo", "processloadingcargo"], title: t("common.status.tabsList.loadingcargo")},
  { key: "onthetrip", statuses: ["onthetrip"], title: t("common.status.tabsList.onthetrip")},
  { key: "unloadingcargo", statuses: ["unloadingcargo", "processunloadingcargo", "unloadingcargomoderation", "return"], title: t("common.status.tabsList.unloadingcargo")},
  { key: "completedbyexecutor", statuses: ["completedbyexecutor"], title: t("common.status.tabsList.underModeration")},
  { key: "completed", statuses: ["completed"], title: t("common.status.tabsList.completed")},
];

export const CLIENT_AIR_TABS = (t) => [
  { key: "all", statuses: ["all"], title: t("common.status.tabs.all")},
  { key: "awaitingOffer", statuses: ["awaitingOffer"], title: t("common.status.tabsAirExpeditor.awaitingOffer"), isExpiredTender: false},
  { key: "expiredTender", statuses: ["awaitingOffer"], title: t("common.status.tabsAirExpeditor.assigned"), isExpiredTender: true},
  { key: "confirmed", statuses: ["accepted", "confirmed"], title: t("common.status.tabsList.confirmed")},
  { key: "OnTheTrip", statuses: ["OnTheTrip"], title: t("common.status.tabsAirExpeditor.onthetrip")},
  { key: "Delivered", statuses: ["Delivered", "return"], title: t("common.status.tabsAirExpeditor.delivered")},
  { key: "completed", statuses: ["completed"], title: t("common.status.tabsAirExpeditor.completed")},
];

export const withClientAirTabTenderFilter = (params, tabKey, t) => {
  const requestParams = { ...params };
  const activeTab = CLIENT_AIR_TABS(t).find((tab) => tab.key === tabKey);

  if (typeof activeTab?.isExpiredTender === "boolean") {
    return { ...requestParams, isExpiredTender: activeTab.isExpiredTender };
  }

  if (activeTab?.key === "all") {
    return requestParams;
  }

  delete requestParams.isExpiredTender;
  return requestParams;
};

export const EXPEDITOR_ALL_STATUSES = [
  "awaitingoffer",
  "assigned",
  "assignedexecutor",
  "confirmed",
  "headingtoloading",
  "processloadingcargo",
  "onthetrip",
  "processunloadingcargo",
  "unloadingcargomoderation",
  "completedbyexecutor",
  "return",
  "completed",
  "canceled",
  "rejected",
];

export const EXPEDITOR_TABS = (t) => [
  { key: "all", statuses: ["all"], title: t("common.status.tabs.all")},
  { key: "tender", statuses: ["awaitingoffer"], title: t("common.status.tabs.tender")},
  { key: "awaitingExpeditor", statuses: ["assigned"], title: t("common.status.tabs.awaitingExpeditor")},
  { key: "assignedexecutor", statuses: ["assignedexecutor", "booked"], title: t("common.status.tabs.assignedExecutor")},
  { key: "processLoadingCargo", statuses: ["confirmed", "processloadingcargo", "loadingcargomoderation", "waitstarttrip", "headingtoloading"], title: t("common.status.tabs.processLoadingCargo")},
  { key: "onthetrip", statuses: ['unloadingcargo', 'loadingcargo', 'onthetrip'], title: t("common.status.tabs.onthetrip")},
  { key: "unloadingCargo", statuses: ["waitcompletion", "processunloadingcargo", "unloadingcargomoderation", "return"], title: t("common.status.tabs.unloadingCargo")},
  { key: "completed", statuses: ["completedbyexecutor", "completed"], title: t("common.status.tabs.completed")},
];

export const EXPEDITOR_AIR_TABS = (t) => [
  { key: "all", statuses: ["all"], title: t("common.status.tabs.all")},
  { key: "awaitingOffer", statuses: ["awaitingOffer"], title: t("common.status.tabsAirExpeditor.awaitingOffer")},
  { key: "awaitingExpeditor", statuses: ["assigned"], title: t("common.status.tabs.awaitingExpeditor")},
  { key: "confirmed", statuses: ["accepted", "confirmed"], title: t("common.status.tabsList.confirmed")},
  { key: "OnTheTrip", statuses: ["OnTheTrip"], title: t("common.status.tabsAirExpeditor.onthetrip")},
  { key: "Delivered", statuses: ["Delivered", "return"], title: t("common.status.tabsAirExpeditor.delivered")},
  { key: "completed", statuses: ["completed"], title: t("common.status.tabsAirExpeditor.completed")},
];

export const ORDER_STATUSES = (t) => ({
    all: t('common.status.tabs.all'),
    awaitingoffer: t('mockData.orderStatuses.awaitingoffer'),
    awaitingaction: t('mockData.orderStatuses.awaitingaction'),
    assigned: t('mockData.orderStatuses.assigned'),
    assignedexecutor: t('mockData.orderStatuses.assignedexecutor'),
    published: t('mockData.orderStatuses.published'),
    booked: t('mockData.orderStatuses.booked'),
    confirmed: t('mockData.orderStatuses.confirmed'),
    headingtoloading: t('mockData.orderStatuses.headingtoloading'),
    processloadingcargo: t('mockData.orderStatuses.processloadingcargo'),
    onthetrip: t('mockData.orderStatuses.onthetrip'),
    processunloadingcargo: t('mockData.orderStatuses.processunloadingcargo'),
    unloadingcargomoderation: t('mockData.orderStatuses.unloadingcargomoderation'),
    completed: t('mockData.orderStatuses.completed'),
    completedbyexecutor: t('mockData.orderStatuses.completedbyexecutor'),
    expeditorrejected: t('mockData.orderStatuses.expeditorrejected'),
    canceled: t('mockData.orderStatuses.canceled'),
    return: t('mockData.orderStatuses.return'),
});

export const ORDER_STATUSES_AIR = (t) => ({
    all: t('common.status.tabs.all'),
    awaitingoffer: t('mockData.orderStatuses.awaitingoffer'),
    awaitingaction: t('mockData.orderStatuses.awaitingaction'),
    assigned: t('mockData.orderStatuses.assigned'),
    accepted: t('mockData.orderStatuses.accepted'),
    onthetrip: t('mockData.orderStatuses.onthetrip'),
    delivered: t('mockData.orderStatuses.delivered'),
    completed: t('mockData.orderStatuses.completed'),
    canceled: t('mockData.orderStatuses.canceled'),
    expeditorRejected: t('mockData.orderStatuses.expeditorrejected'),
});

export const ORDER_STATUSES_KEY = {
    moderation: "moderation",
    awaitingpayment: "awaitingpayment",
    assigned: "assigned",
    published: "published",
    booked: "booked",
    confirmed: "confirmed",
    processloadingcargo: "processloadingcargo",
    loadingcargomoderation: "loadingcargomoderation",
    rejectedloadingcargomoderation: "rejectedloadingcargomoderation",
    waitstarttrip: "waitstarttrip",
    onthetrip: "onthetrip",
    processunloadingcargo: "processunloadingcargo",
    unloadingcargomoderation: "unloadingcargomoderation",
    completedbyexecutor: "completedbyexecutor",
    rejectedunloadingcargomoderation: "rejectedunloadingcargomoderation",
    completed: "completed",
    rejected: "rejected",
    canceled: "canceled",
    return: "return"
}

export const REJECT_STATUSES = {
    reject: "reject",
    rejectbook: "rejectbook",
    rejectloadingcargo: "rejectloadingcargo",
    rejectedUnloadingCargoModeration: "rejectedUnloadingCargoModeration"
}

export const acceptstatus = (status) => {
    switch (status) {
        case ORDER_STATUSES_KEY.assigned:
            return ORDER_STATUSES_KEY.published;
            break;
        case ORDER_STATUSES_KEY.unloadingcargomoderation:
            return ORDER_STATUSES_KEY.completed;
            break;
        case ORDER_STATUSES_KEY.completedbyexecutor:
            return ORDER_STATUSES_KEY.completed;
            break;
    }
}

export const rejectstatus = (status) => {
    switch (status) {
        case ORDER_STATUSES_KEY.moderation:
            return REJECT_STATUSES.reject;
            break;
        case ORDER_STATUSES_KEY.booked:
            return REJECT_STATUSES.rejectbook;
            break;
        case ORDER_STATUSES_KEY.loadingcargomoderation:
            return REJECT_STATUSES.rejectloadingcargo;
            break;
        case ORDER_STATUSES_KEY.unloadingcargomoderation:
            return ORDER_STATUSES_KEY.onthetrip;
            break;
        case ORDER_STATUSES_KEY.completedbyexecutor:
            return ORDER_STATUSES_KEY.return;
            break;
    }
}

export const CURRENCIES = {
  KZT: { symbol: "〒", code: "KZT" },
  USD: { symbol: "$", code: "USD" },
  EUR: { symbol: "€", code: "EUR" },
  UZS: { symbol: "UZS", code: "UZS" },
};

export const TRANSPORT_TYPE_ICONS = {
  refrigerator: RefrigeratorIcon,
  isothermal: IsothermalIcon,
  covered: CoveredIcon,
  awning: AwningIcon,
  onboard: OnboardIcon,
  platform: PlatformIcon,
  cistern: CisternIcon,
  container_ship: ContainerShipIcon,
  dump_truck: DumpTruckIcon,
  car_transporter: CarTransporterIcon,
  railway_shipment: RailwayIcon,
  railway_shipment_40: RailwayIcon,
  container: ContainerIcon,
};

export const getTransportTypeIcon = (value) => {
  return TRANSPORT_TYPE_ICONS[value] || null;
};


export const WEIGHT_UNITS = (t) => ({
  kg: {
    symbol: t("orderInfo.ordersInfoCargo.kgUnit"),
    name: t("orderInfo.ordersInfoCargo.kgUnit"),
    code: "Kg",
    key: "kg"
  },
  ton: {
    symbol: t("orderInfo.ordersInfoCargo.tonsUnit"),
    name: t("orderInfo.ordersInfoCargo.tonsUnit"),
    code: "Ton",
    key: "ton"
  },
});

export const NOTIFICATION_TYPES = (t) => ({
  PARTNERSHIP: { key: "PARTNERSHIP", name: t("notificationPage.types.PARTNERSHIP"), link: "/partners" },
  MESSAGES: { key: "MESSAGES", name: t("notificationPage.types.MESSAGES"), link: "/notification" },
  COMPANY: { key: "COMPANY", name: t("notificationPage.types.COMPANY"), link: "/notification" },
  EMPLOYEES: { key: "EMPLOYEES", name: t("notificationPage.types.EMPLOYEES"), link: "/workers" },
  MARKETPLACE: { key: "MARKETPLACE", name: t("notificationPage.types.MARKETPLACE"), link: "/marketplace" },
});

export const POINT_TYPES = {
  Loading: 0,
  Unloading: 1,
};
